import NavLink2 from "../compnents/NavLink2";
import Team from "../images/team.png";
import Footer4 from "../compnents/Footer4";
import Footer5 from "../compnents/Footer5";
import { Col, Container, Row } from "react-bootstrap";


const TermAndConditions = () => {

	const darkGrayStyle = {
    color: '#333333',
    backgroundColor: '#ffffff',
    lineHeight: '1.6'
  };

	return (
		<div className="privacy-policy-page">
			<div
				className="main-MF"
				style={{
					backgroundImage: `url(${Team})`,
					backgroundRepeat: "no-repeat",
					backgroundSize: "cover",
					height: "150px",
					textAlign: "center",
					boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.1)"
				}}
			>
				<div>
					<NavLink2 />
					<h1>Terms And Conditions</h1>
				</div>
			</div>
			<Container fluid className="policy pt-5 pb-5 px-5 ">
				<div className="policy-content w-max-w-6xl mx-auto">
					<div className="row mb-4">
						<h2 className="h4 fw-bold mb-3 text-center">Terms and Conditions of Use</h2>
						<p>
							Welcome to our Terms and Conditions of Use. These terms affect your legal rights;
							endeavour to read them and treat them with utmost importance.
						</p>
						<p>
							These terms and conditions (<strong>“Terms”</strong> or <strong>“Agreement”</strong>) are an agreement between
							<strong> TrustBanc</strong> (“the Company”, “us”, “we”, or “our”) and you (“User”, “you”, or “your”).
							This Agreement sets forth the general terms and conditions of your use of the TrustBanc mobile
							application and any of its products or services (collectively, the “Application” or “Services”).
						</p>
					</div>

					<div className="row g-4">
						{/* Accounts and Registration */}
						<div className="col-12">
							<h2 className="h4 fw-bold mb-3">Accounts and Registration</h2>
							<p>You must register to operate an account with the Company to be able to use the mobile Application. The Application can be installed on a mobile device running an operating system supported by the Company.</p>
							<p>To log onto the Application, you will need to enter your User ID and other security information that we request, or where available, by using biometric authentication. We will automatically log you out of the Application if you have not used it for 15 minutes.</p>
							<p>If you create an account in the Application, you are responsible for maintaining the security of your account and are fully responsible for all activities that occur under the account. Providing false contact information of any kind may result in the termination of your account.</p>
						</div>

						{/* Qualification */}
						<div className="col-12">
							<h2 className="h4 fw-bold mb-3">Qualification for Use</h2>
							<p>TrustBanc Products are available only to people aged <strong>18 or over</strong>. Individuals under the age of 18 may utilize the service only with the involvement of a parent or legal guardian, under such a person’s account.</p>
						</div>

						{/* Services Provided */}
						<div className="col-12">
							<h2 className="h4 fw-bold mb-3">Services Provided</h2>
							<div className="ps-3 border-start border-3">
								<ul className="list-unstyled">
									<li className="mb-2"><strong>• Savings Account:</strong> Open, manage, and operate savings accounts</li>
									<li className="mb-2"><strong>• Fixed Deposit:</strong> Invest in fixed deposits and track maturity details</li>
									<li className="mb-2"><strong>• Loans:</strong> Apply for and manage loans</li>
									<li className="mb-2"><strong>• Mutual Funds:</strong> Invest in and track mutual fund portfolios</li>
									<li className="mb-2"><strong>• Future Updates:</strong> Additional services as introduced</li>
								</ul>
							</div>
						</div>

						{/* Specific Product Terms Grid */}
						<div className="col-md-6">
							<h3 className="h5 fw-bold">Loan Services Terms</h3>
							<p className="small">Loan approvals are subject to eligibility checks and credit assessments. Defaulting on loan repayments may result in penalties, legal action, and adverse credit reporting.</p>
						</div>

						<div className="col-md-6">
							<h3 className="h5 fw-bold">Mutual Funds Terms</h3>
							<p className="small">Mutual fund investments are subject to market risks. Past performance is not indicative of future results. The Company is not liable for financial losses.</p>
						</div>

						{/* Suspension & Legal */}
						<div className="col-12 mt-4 pt-4 border-top">
							<h2 className="h4 fw-bold mb-3">Suspension of the Mobile Application</h2>
							<p>TrustBanc may suspend your access if there are security concerns, suspected fraudulent use, or legal/regulatory obligations require it.</p>
						</div>

						{/* Dispute Resolution */}
						<div className="col-12 bg-light p-4 rounded">
							<h2 className="h4 fw-bold mb-3">Dispute Resolution</h2>
							<p className="mb-0">These Terms are governed by the laws of the <strong>Federal Republic of Nigeria</strong>. Disputes shall be resolved through mutual discussion, mediation, or arbitration in Lagos State, Nigeria.</p>
						</div>

						{/* Contact info */}
						<div className="col-12 text-center mt-5">
							<p className="mb-1 fw-bold">Acceptance of These Terms</p>
							<p className="small mb-4">By using the Application, you acknowledge that you have read, understood, and agreed to these Terms.</p>
							<div className="p-3 bg-white border d-inline-block rounded">
								<span className="me-2">Contact Us:</span>
								<a href="mailto:support@trustbancgroup.com" className="text-decoration-none fw-bold" style={{ color: '#555' }}>
									support@trustbancgroup.com
								</a>
							</div>
						</div>
					</div>
				</div>
			</Container>
			<div>
				<Footer5 />
			</div>
			<div className="footer-4">
				<Footer4 />
			</div>
		</div>
	);
};

export default TermAndConditions;
